/* bios-audio.js — Web Audio synthesizer for all UI sound effects.
   Extracted from main-content.liquid to stay within Shopify's 256 KB limit.
   Loaded synchronously so BiosAudio is available before other inline scripts. */
var BiosAudio = (function() {
  var _ctx     = null;
  var _ready   = false;
  var _lastTick = 0;
  /* Default UNMUTED so the new SH-style cues (portalEnter, itemClick)
     play on first visit. Previously defaulted to true with no visible
     toggle on the storefront — users had no way to hear anything.
     localStorage still wins: if a user explicitly muted, that
     preference is honoured. */
  var _muted   = false;
  var _humSrc  = null;
  var _humNode = null;

  /* Restore saved sound preference. '0' = explicitly muted; anything
     else (or nothing saved) → keep the default-unmuted state. */
  try { if (localStorage.getItem('bios_snd') === '0') _muted = true; } catch(e) {}

  function _getCtx() {
    if (!_ctx) {
      try { _ctx = new (window.AudioContext || window.webkitAudioContext)(); } catch(e) {}
    }
    return _ctx;
  }

  /* Unlock on first user gesture — required by browser autoplay policy */
  function _unlock() {
    if (_ready) return;
    _ready = true;
    var c = _getCtx();
    if (c && c.state === 'suspended') c.resume();
  }
  ['click','keydown','touchstart'].forEach(function(ev) {
    document.addEventListener(ev, _unlock, { once: true, passive: true });
  });

  /* Scan beep: short high ping fired on drum item change */
  function scanBeep() {
    if (!_ready || _muted) return;
    var c = _getCtx(); if (!c) return;
    var osc = c.createOscillator(), g = c.createGain();
    osc.connect(g); g.connect(c.destination);
    osc.type = 'sine'; osc.frequency.value = 1150;
    g.gain.setValueAtTime(0.032, c.currentTime);
    g.gain.exponentialRampToValueAtTime(0.0001, c.currentTime + 0.048);
    osc.start(); osc.stop(c.currentTime + 0.048);
  }

  /* Portal tone: low sine on [BIOS] hover */
  function portalTone(choice) {
    if (!_ready || _muted) return;
    if (choice !== 'bios') return;
    var c = _getCtx(); if (!c) return;
    var osc = c.createOscillator(), g = c.createGain();
    osc.connect(g); g.connect(c.destination);
    osc.type = 'sine'; osc.frequency.value = 520;
    g.gain.setValueAtTime(0.055, c.currentTime);
    g.gain.exponentialRampToValueAtTime(0.0001, c.currentTime + 0.18);
    osc.start(); osc.stop(c.currentTime + 0.18);
  }

  /* Cart beep: ascending two-tone ping on successful add */
  function cartBeep() {
    if (!_ready || _muted) return;
    var c = _getCtx(); if (!c) return;
    [880, 1100].forEach(function(freq, i) {
      var osc = c.createOscillator(), g = c.createGain();
      osc.connect(g); g.connect(c.destination);
      osc.type = 'sine'; osc.frequency.value = freq;
      var t = c.currentTime + i * 0.09;
      g.gain.setValueAtTime(0.048, t);
      g.gain.exponentialRampToValueAtTime(0.0001, t + 0.085);
      osc.start(t); osc.stop(t + 0.085);
    });
  }

  /* Line beep: short acknowledgement tone after each boot line */
  function lineBeep() {
    if (!_ready || _muted) return;
    var c = _getCtx(); if (!c) return;
    var osc = c.createOscillator(), g = c.createGain();
    osc.connect(g); g.connect(c.destination);
    osc.type = 'sine'; osc.frequency.value = 390;
    g.gain.setValueAtTime(0.038, c.currentTime);
    g.gain.exponentialRampToValueAtTime(0.0001, c.currentTime + 0.065);
    osc.start(); osc.stop(c.currentTime + 0.065);
  }

  /* Floppy disk load: motor hum + rhythmic seek clicks */
  function floppyLoad(totalMs) {
    if (!_ready || _muted) return;
    var c = _getCtx(); if (!c) return;
    var dur = totalMs / 1000;
    var end = c.currentTime + dur;
    var mN   = Math.ceil(c.sampleRate * dur);
    var mBuf = c.createBuffer(1, mN, c.sampleRate);
    var mDat = mBuf.getChannelData(0);
    for (var mi = 0; mi < mN; mi++) mDat[mi] = Math.random() * 2 - 1;
    var mSrc = c.createBufferSource(), mFlt = c.createBiquadFilter(), mGain = c.createGain();
    mSrc.buffer = mBuf;
    mFlt.type = 'lowpass'; mFlt.frequency.value = 180;
    mGain.gain.value = 0.038;
    mSrc.connect(mFlt); mFlt.connect(mGain); mGain.connect(c.destination);
    mSrc.start(c.currentTime); mSrc.stop(end);
    var t = c.currentTime + 0.08;
    while (t < end - 0.05) {
      var sDur = 0.032 + Math.random() * 0.028;
      var sN   = Math.ceil(c.sampleRate * sDur);
      var sBuf = c.createBuffer(1, sN, c.sampleRate);
      var sDat = sBuf.getChannelData(0);
      for (var si = 0; si < sN; si++) sDat[si] = Math.random() * 2 - 1;
      var sSrc = c.createBufferSource(), sFlt = c.createBiquadFilter(), sGain = c.createGain();
      sSrc.buffer = sBuf;
      sFlt.type = 'bandpass'; sFlt.frequency.value = 700 + Math.random() * 500; sFlt.Q.value = 2.5;
      sGain.gain.setValueAtTime(0.11, t);
      sGain.gain.exponentialRampToValueAtTime(0.0001, t + sDur);
      sSrc.connect(sFlt); sFlt.connect(sGain); sGain.connect(c.destination);
      sSrc.start(t); sSrc.stop(t + sDur);
      t += 0.12 + Math.random() * 0.09;
    }
  }

  /* Typing tick: very subtle per-character click */
  function typingTick() {
    if (!_ready || _muted) return;
    var now = Date.now();
    if (now - _lastTick < 18) return;
    _lastTick = now;
    var c = _getCtx(); if (!c) return;
    var dur  = 0.011;
    var n    = Math.ceil(c.sampleRate * dur);
    var buf  = c.createBuffer(1, n, c.sampleRate);
    var data = buf.getChannelData(0);
    for (var i = 0; i < n; i++) {
      data[i] = (Math.random() * 2 - 1) * Math.pow(Math.max(0, 1 - i / n), 2.5);
    }
    var src = c.createBufferSource(), flt = c.createBiquadFilter(), g = c.createGain();
    src.buffer = buf;
    flt.type = 'highpass'; flt.frequency.value = 1900;
    g.gain.value = 0.02;
    src.connect(flt); flt.connect(g); g.connect(c.destination);
    src.start(); src.stop(c.currentTime + dur);
  }

  /* Boot milestone tone */
  function bootTone(step) {
    if (!_ready || _muted) return;
    var c = _getCtx(); if (!c) return;
    var freqs = { 50: 220, 90: 440, 100: 880 };
    var freq = freqs[step]; if (!freq) return;
    var osc = c.createOscillator(), g = c.createGain();
    osc.connect(g); g.connect(c.destination);
    osc.type = 'sine'; osc.frequency.value = freq;
    g.gain.setValueAtTime(0.038, c.currentTime);
    g.gain.exponentialRampToValueAtTime(0.0001, c.currentTime + 0.22);
    osc.start(); osc.stop(c.currentTime + 0.22);
  }

  function _stopHum() {
    if (_humSrc) { try { _humSrc.stop(); } catch(e) {} _humSrc = null; }
    _humNode = null;
  }

  /* CRT hum — looping low-freq tone + noise */
  function crtHum() {
    if (!_ready || _muted) return;
    _stopHum();
    var c = _getCtx(); if (!c) return;
    var dur = 2.0;
    var n   = Math.ceil(c.sampleRate * dur);
    var buf = c.createBuffer(1, n, c.sampleRate);
    var dat = buf.getChannelData(0);
    for (var i = 0; i < n; i++) {
      dat[i] = Math.sin(2 * Math.PI * 60 * i / c.sampleRate) * 0.55 +
               (Math.random() * 2 - 1) * 0.45;
    }
    var src = c.createBufferSource();
    src.buffer = buf; src.loop = true;
    var lp  = c.createBiquadFilter(); lp.type = 'lowpass'; lp.frequency.value = 110;
    var g   = c.createGain(); g.gain.value = 0.007;
    src.connect(lp); lp.connect(g); g.connect(c.destination);
    src.start();
    _humSrc = src; _humNode = g;
  }

  /* Page static burst — brief bandpass noise on page transition */
  function pageStaticBurst() {
    if (!_ready || _muted) return;
    var c = _getCtx(); if (!c) return;
    var dur = 0.20;
    var n   = Math.ceil(c.sampleRate * dur);
    var buf = c.createBuffer(1, n, c.sampleRate);
    var dat = buf.getChannelData(0);
    for (var i = 0; i < n; i++) dat[i] = Math.random() * 2 - 1;
    var src = c.createBufferSource(); src.buffer = buf;
    var flt = c.createBiquadFilter(); flt.type = 'bandpass'; flt.frequency.value = 900; flt.Q.value = 0.7;
    var g   = c.createGain();
    g.gain.setValueAtTime(0.045, c.currentTime);
    g.gain.exponentialRampToValueAtTime(0.0001, c.currentTime + dur);
    src.connect(flt); flt.connect(g); g.connect(c.destination);
    src.start(); src.stop(c.currentTime + dur);
  }

  /* ── Scroll / highlight / checkout sounds ── */
  var _lastScrollTick = 0, _lastSeek = 0, _lastPiezo = 0;

  /* Scroll tick — floppy sector click per item crossing centre */
  function scrollTick() {
    if (!_ready || _muted) return;
    var now = Date.now(); if (now - _lastScrollTick < 35) return; _lastScrollTick = now;
    var c = _getCtx(); if (!c) return;
    var dur = 0.016, n = Math.ceil(c.sampleRate * dur);
    var buf = c.createBuffer(1, n, c.sampleRate), dat = buf.getChannelData(0);
    for (var i = 0; i < n; i++) dat[i] = (Math.random() * 2 - 1) * Math.pow(Math.max(0, 1 - i / n), 3.0);
    var src = c.createBufferSource(); src.buffer = buf;
    var flt = c.createBiquadFilter(); flt.type = 'bandpass'; flt.frequency.value = 1100; flt.Q.value = 1.8;
    var g = c.createGain();
    g.gain.setValueAtTime(0.065, c.currentTime);
    g.gain.exponentialRampToValueAtTime(0.0001, c.currentTime + dur);
    src.connect(flt); flt.connect(g); g.connect(c.destination);
    src.start(); src.stop(c.currentTime + dur);
  }

  /* Seek noise — HDD head movement, velocity-scaled */
  function seekNoise(velocity) {
    if (!_ready || _muted) return;
    var speed = Math.min(Math.abs(velocity) / 55, 1.0); if (speed < 0.06) return;
    var now = Date.now(); if (now - _lastSeek < 22) return; _lastSeek = now;
    var c = _getCtx(); if (!c) return;
    var dur = 0.022 + speed * 0.028, n = Math.ceil(c.sampleRate * dur);
    var buf = c.createBuffer(1, n, c.sampleRate), dat = buf.getChannelData(0);
    for (var i = 0; i < n; i++) dat[i] = Math.random() * 2 - 1;
    var src = c.createBufferSource(); src.buffer = buf;
    var flt = c.createBiquadFilter(); flt.type = 'bandpass';
    flt.frequency.value = 500 + speed * 900; flt.Q.value = 2.8;
    var g = c.createGain();
    g.gain.setValueAtTime(0.025 + speed * 0.045, c.currentTime);
    g.gain.exponentialRampToValueAtTime(0.0001, c.currentTime + dur);
    src.connect(flt); flt.connect(g); g.connect(c.destination);
    src.start(); src.stop(c.currentTime + dur);
  }

  /* Page flip — floppy spin-up + seek clicks */
  function pageFlipSound() {
    if (!_ready || _muted) return;
    var c = _getCtx(); if (!c) return;
    var osc = c.createOscillator(), go = c.createGain();
    osc.connect(go); go.connect(c.destination); osc.type = 'sawtooth';
    osc.frequency.setValueAtTime(75, c.currentTime);
    osc.frequency.exponentialRampToValueAtTime(320, c.currentTime + 0.14);
    go.gain.setValueAtTime(0.055, c.currentTime);
    go.gain.exponentialRampToValueAtTime(0.0001, c.currentTime + 0.20);
    osc.start(); osc.stop(c.currentTime + 0.20);
    [0.02, 0.075, 0.14].forEach(function(delay) {
      var dur = 0.020, n = Math.ceil(c.sampleRate * dur);
      var buf = c.createBuffer(1, n, c.sampleRate), dat = buf.getChannelData(0);
      for (var i = 0; i < n; i++) dat[i] = (Math.random() * 2 - 1) * Math.pow(Math.max(0, 1 - i / n), 2.5);
      var src = c.createBufferSource(); src.buffer = buf;
      var flt = c.createBiquadFilter(); flt.type = 'bandpass';
      flt.frequency.value = 850 + Math.random() * 350; flt.Q.value = 2.2;
      var sg = c.createGain();
      sg.gain.setValueAtTime(0.13, c.currentTime + delay);
      sg.gain.exponentialRampToValueAtTime(0.0001, c.currentTime + delay + dur);
      src.connect(flt); flt.connect(sg); sg.connect(c.destination);
      src.start(c.currentTime + delay); src.stop(c.currentTime + delay + dur);
    });
  }

  /* Highlight piezo — tiny square-wave chirp on hover */
  function highlightPiezo() {
    if (!_ready || _muted) return;
    var now = Date.now(); if (now - _lastPiezo < 90) return; _lastPiezo = now;
    var c = _getCtx(); if (!c) return;
    var osc = c.createOscillator(), g = c.createGain();
    osc.connect(g); g.connect(c.destination); osc.type = 'square';
    osc.frequency.value = 2600 + Math.random() * 500;
    g.gain.setValueAtTime(0.010, c.currentTime);
    g.gain.exponentialRampToValueAtTime(0.0001, c.currentTime + 0.020);
    osc.start(); osc.stop(c.currentTime + 0.020);
  }

  /* Checkout connect — modem handshake sequence. Ducks the YouTube music
     by 50% for ~1s so the handshake reads clean over the soundtrack. */
  function checkoutConnect() {
    if (!_ready || _muted) return;
    var c = _getCtx(); if (!c) return;
    try { if (window._biosPlayerDuck) window._biosPlayerDuck(0.5, 1100); } catch (_) {}
    var t = c.currentTime;
    [440, 480].forEach(function(f) {
      var o = c.createOscillator(), g = c.createGain();
      o.connect(g); g.connect(c.destination); o.type = 'sine'; o.frequency.value = f;
      g.gain.setValueAtTime(0.038, t); g.gain.exponentialRampToValueAtTime(0.0001, t + 0.14);
      o.start(t); o.stop(t + 0.14);
    });
    [820, 1250, 1900].forEach(function(f, i) {
      var d = 0.17 + i * 0.12;
      var o = c.createOscillator(), g = c.createGain();
      o.connect(g); g.connect(c.destination); o.type = 'sine';
      o.frequency.setValueAtTime(f * 0.65, t + d); o.frequency.linearRampToValueAtTime(f, t + d + 0.09);
      g.gain.setValueAtTime(0.038, t + d); g.gain.exponentialRampToValueAtTime(0.0001, t + d + 0.10);
      o.start(t + d); o.stop(t + d + 0.10);
    });
    var bt = t + 0.56, bdur = 0.16, bn = Math.ceil(c.sampleRate * bdur);
    var bbuf = c.createBuffer(1, bn, c.sampleRate), bdat = bbuf.getChannelData(0);
    for (var bi = 0; bi < bn; bi++) bdat[bi] = Math.random() * 2 - 1;
    var bsrc = c.createBufferSource(); bsrc.buffer = bbuf;
    var bflt = c.createBiquadFilter(); bflt.type = 'bandpass'; bflt.frequency.value = 1700; bflt.Q.value = 0.9;
    var bg = c.createGain(); bg.gain.setValueAtTime(0.038, bt); bg.gain.exponentialRampToValueAtTime(0.0001, bt + bdur);
    bsrc.connect(bflt); bflt.connect(bg); bg.connect(c.destination);
    bsrc.start(bt); bsrc.stop(bt + bdur);
    [900, 1350].forEach(function(f, i) {
      var ct = t + 0.76 + i * 0.11;
      var o = c.createOscillator(), g = c.createGain();
      o.connect(g); g.connect(c.destination); o.type = 'sine'; o.frequency.value = f;
      g.gain.setValueAtTime(0.052, ct); g.gain.exponentialRampToValueAtTime(0.0001, ct + 0.13);
      o.start(ct); o.stop(ct + 0.13);
    });
  }

  /* overlayOpen / overlayClose / portalEnter / itemClick:
     These were the original Web-Audio synth cues. Every call site
     also triggers a click event, and the global HTML5 <audio> click
     handler in theme.liquid now plays a user-uploaded WAV for every
     click. Without no-op'ing these the user heard TWO sounds per
     interaction — the synth + the WAV. Stubbing them out makes the
     HTML5 handler the single source of click audio. Function names
     preserved so existing call sites in bios-cart, bios-chat-panel,
     bios-main, etc. don't error. */
  function overlayOpen()  { /* no-op — handled by theme.liquid click handler */ }
  function overlayClose() { /* no-op — handled by theme.liquid click handler */ }
  function _overlayCloseSynthLEGACY() {
    /* Original implementation preserved here in case we ever want to
       re-enable the synth alongside the WAV. Not wired to anything. */
    if (!_ready || _muted) return;
    var c = _getCtx(); if (!c) return;
    var t = c.currentTime;
    var o = c.createOscillator(), g = c.createGain();
    o.connect(g); g.connect(c.destination);
    o.type = 'sine';
    o.frequency.setValueAtTime(360, t);
    o.frequency.linearRampToValueAtTime(160, t + 0.10);
    g.gain.setValueAtTime(0.036, t);
    g.gain.exponentialRampToValueAtTime(0.0001, t + 0.12);
    o.start(t); o.stop(t + 0.13);
    /* tail click */
    scrollTick();
  }

  /* Cart remove: short bandpass crackle + descending blip — "memory page evicted" */
  function cartRemove() {
    if (!_ready || _muted) return;
    var c = _getCtx(); if (!c) return;
    var t = c.currentTime;
    var dur = 0.08, n = Math.ceil(c.sampleRate * dur);
    var buf = c.createBuffer(1, n, c.sampleRate), dat = buf.getChannelData(0);
    for (var i = 0; i < n; i++) dat[i] = (Math.random() * 2 - 1) * (1 - i / n);
    var src = c.createBufferSource(); src.buffer = buf;
    var flt = c.createBiquadFilter(); flt.type = 'bandpass'; flt.frequency.value = 900; flt.Q.value = 1.4;
    var g = c.createGain(); g.gain.setValueAtTime(0.034, t); g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
    src.connect(flt); flt.connect(g); g.connect(c.destination);
    src.start(t); src.stop(t + dur);
    /* descending tail blip */
    var o = c.createOscillator(), og = c.createGain();
    o.connect(og); og.connect(c.destination);
    o.type = 'sine';
    o.frequency.setValueAtTime(1100, t + dur);
    o.frequency.exponentialRampToValueAtTime(440, t + dur + 0.10);
    og.gain.setValueAtTime(0.028, t + dur);
    og.gain.exponentialRampToValueAtTime(0.0001, t + dur + 0.12);
    o.start(t + dur); o.stop(t + dur + 0.13);
  }

  /* Low-power enter: deep spin-down sweep + closing low-pass */
  function lowPowerEnter() {
    if (!_ready || _muted) return;
    var c = _getCtx(); if (!c) return;
    var t = c.currentTime;
    var o = c.createOscillator(), g = c.createGain(), f = c.createBiquadFilter();
    o.connect(f); f.connect(g); g.connect(c.destination);
    o.type = 'sine';
    o.frequency.setValueAtTime(220, t);
    o.frequency.exponentialRampToValueAtTime(55, t + 0.85);
    f.type = 'lowpass';
    f.frequency.setValueAtTime(1600, t);
    f.frequency.exponentialRampToValueAtTime(220, t + 0.85);
    g.gain.setValueAtTime(0.042, t);
    g.gain.exponentialRampToValueAtTime(0.0001, t + 0.95);
    o.start(t); o.stop(t + 1.0);
    /* fade the hum out alongside so the silence becomes conspicuous */
    if (_humNode) {
      try {
        _humNode.gain.cancelScheduledValues(t);
        _humNode.gain.setValueAtTime(_humNode.gain.value, t);
        _humNode.gain.exponentialRampToValueAtTime(0.0001, t + 0.85);
      } catch (_) {}
    }
  }

  /* Low-power exit: sharp click + reverse swell, then hum resumes */
  function lowPowerExit() {
    if (!_ready || _muted) return;
    var c = _getCtx(); if (!c) return;
    var t = c.currentTime;
    /* spin-up click */
    scrollTick();
    /* swelling burst */
    var dur = 0.20, n = Math.ceil(c.sampleRate * dur);
    var buf = c.createBuffer(1, n, c.sampleRate), dat = buf.getChannelData(0);
    for (var i = 0; i < n; i++) dat[i] = (Math.random() * 2 - 1) * (i / n);
    var src = c.createBufferSource(); src.buffer = buf;
    var flt = c.createBiquadFilter(); flt.type = 'bandpass'; flt.frequency.value = 1400; flt.Q.value = 0.8;
    var g = c.createGain(); g.gain.setValueAtTime(0.0001, t + 0.05); g.gain.exponentialRampToValueAtTime(0.038, t + 0.05 + dur);
    src.connect(flt); flt.connect(g); g.connect(c.destination);
    src.start(t + 0.05); src.stop(t + 0.05 + dur);
    /* resume hum if it was running and got faded */
    if (_humNode) {
      try {
        _humNode.gain.cancelScheduledValues(t);
        _humNode.gain.setValueAtTime(0.0001, t);
        _humNode.gain.exponentialRampToValueAtTime(0.007, t + 0.30);
      } catch (_) {}
    }
  }

  /* Transmit: morse-style "packet dispatched" — two short tones + final tone */
  function transmit() {
    if (!_ready || _muted) return;
    var c = _getCtx(); if (!c) return;
    var t = c.currentTime;
    [[440, 0.00], [440, 0.14], [1100, 0.28]].forEach(function (pair) {
      var f = pair[0], dt = pair[1];
      var o = c.createOscillator(), g = c.createGain();
      o.connect(g); g.connect(c.destination);
      o.type = 'sine'; o.frequency.value = f;
      var dur = (f === 1100) ? 0.10 : 0.06;
      g.gain.setValueAtTime(0.038, t + dt);
      g.gain.exponentialRampToValueAtTime(0.0001, t + dt + dur);
      o.start(t + dt); o.stop(t + dt + dur);
    });
  }

  /* Designer drill-in: 3 ascending radar pings */
  function designerEngage() {
    if (!_ready || _muted) return;
    bootTone(50);
    setTimeout(function () { bootTone(90); }, 90);
    setTimeout(function () { bootTone(100); }, 180);
  }

  /* Designer drill-out: descending sweep */
  function designerDisengage() {
    if (!_ready || _muted) return;
    var c = _getCtx(); if (!c) return;
    var t = c.currentTime;
    var o = c.createOscillator(), g = c.createGain();
    o.connect(g); g.connect(c.destination);
    o.type = 'sine';
    o.frequency.setValueAtTime(880, t);
    o.frequency.exponentialRampToValueAtTime(220, t + 0.22);
    g.gain.setValueAtTime(0.032, t);
    g.gain.exponentialRampToValueAtTime(0.0001, t + 0.24);
    o.start(t); o.stop(t + 0.25);
  }

  /* Search popup open: floppy-seek truncated */
  function searchOpen() {
    if (!_ready || _muted) return;
    scrollTick();
    setTimeout(function () { bootTone(90); }, 60);
  }

  /* Music gain ducking — for checkoutConnect to mute the YouTube player
     while the modem handshake plays. Caller passes 0.0–1.0 mult and ms. */
  function duckMusic(targetMult, durMs) {
    try {
      if (window._biosPlayerDuck) window._biosPlayerDuck(targetMult, durMs);
    } catch (_) {}
  }

  function setMuted(v) {
    _muted = !!v;
    if (_muted) { _stopHum(); }
    try { localStorage.setItem('bios_snd', _muted ? '0' : '1'); } catch(e) {}
  }

  function isMuted() { return _muted; }

  /* ── Sample playback layer ────────────────────────────────────────────
     Bridge for ElevenLabs / Freesound / hand-recorded MP3 cues. Each
     named sample is fetched once (decoded to an AudioBuffer), cached,
     and replayed via BufferSource. If the file doesn't exist (404) or
     the user is on a browser without fetch+decodeAudioData, we silently
     fall back to the synthesized counterpart so the site never breaks
     when assets are missing.

     Naming convention: place files at `/assets/sfx-<name>.mp3` and they
     resolve automatically. URLs are passed in via the registerSample()
     hook from a Liquid-aware loader (see main-content.liquid for the
     `BiosAudio.registerSample('portal-enter', '{{ "sfx-portal-enter.mp3" | asset_url }}')`
     calls) — Web Audio can't resolve Liquid filters on its own.

     Volume: each sample gets a per-cue gain so we can match the synth
     levels (~-30dB peak) without re-normalising the source MP3. Tweak
     in SAMPLE_GAIN if a cue lands too hot/soft. */
  var _sampleUrls    = {};   /* name → url */
  var _sampleBuffers = {};   /* name → decoded AudioBuffer */
  var _sampleStatus  = {};   /* name → 'loading' | 'ready' | 'missing' */
  var SAMPLE_GAIN = {
    'portal-enter': 0.55,
    'item-click':   0.45,
    /* Universal button-click sound — user-uploaded WAV registered from
       theme.liquid. Single source of truth for every click on the site.
       Pushed to 1.0 because the source WAV peaks well below full scale —
       at 0.65 it landed below the threshold of "did I hear that". */
    'button-click': 1.0
  };

  function registerSample(name, url) {
    if (!name || !url) return;
    /* Honour the existing registration if the URL hasn't changed; lets
       the Liquid template call registerSample() on every page load
       without triggering a re-fetch. */
    if (_sampleUrls[name] === url) return;
    _sampleUrls[name] = url;
    _sampleStatus[name] = 'loading';
    _loadSample(name);
  }

  function _loadSample(name) {
    var url = _sampleUrls[name];
    if (!url) return;
    /* Need an AudioContext to decode into. If one doesn't exist yet
       (user hasn't gestured), defer to the unlock handler below. */
    var c = _getCtx();
    if (!c) { _sampleStatus[name] = 'missing'; return; }
    fetch(url)
      .then(function (r) {
        if (!r.ok) throw new Error('sfx ' + name + ' ' + r.status);
        return r.arrayBuffer();
      })
      .then(function (ab) {
        return new Promise(function (resolve, reject) {
          c.decodeAudioData(ab, resolve, reject);
        });
      })
      .then(function (buf) {
        _sampleBuffers[name] = buf;
        _sampleStatus[name] = 'ready';
      })
      .catch(function () {
        _sampleStatus[name] = 'missing';
      });
  }

  function _playSample(name) {
    if (!_ready || _muted) return false;
    var buf = _sampleBuffers[name];
    if (!buf) return false;
    var c = _getCtx(); if (!c) return false;
    var src = c.createBufferSource();
    src.buffer = buf;
    var g = c.createGain();
    g.gain.value = SAMPLE_GAIN[name] != null ? SAMPLE_GAIN[name] : 0.45;
    src.connect(g); g.connect(c.destination);
    src.start();
    return true;
  }

  /* On user-gesture unlock, retry any samples that registered before
     the AudioContext existed. */
  ['click','keydown','touchstart'].forEach(function (ev) {
    document.addEventListener(ev, function () {
      Object.keys(_sampleStatus).forEach(function (name) {
        if (_sampleStatus[name] === 'missing' && _sampleUrls[name]) {
          _loadSample(name);
        }
      });
    }, { once: true, passive: true });
  });

  /* ── Public signature cues ────────────────────────────────────────────
     portalEnter — fires on EXPERIENCE click. Prefer the MP3 sample; if
     the file isn't deployed yet, fall back to the SH-style synth
     defined below (low EM thump → metallic resonance → static dust →
     clean signal lock).
     itemClick — fires when a catalog item opens its overlay. Prefer the
     MP3 sample; fall back to the SH1-inventory-style synth click. */

  /* ── SH1 inventory click (synthesized) ──────────────────────────────
     Recipe matching the Silent Hill 1 inventory-menu UI sound, built
     procedurally so there's zero IP risk vs. ripping the actual game
     audio. Three components stacked:
       1. 30ms metallic tick — narrow bandpass noise around 1.7 kHz
          gives the sharp metallic edge.
       2. 280ms decaying sine pair at 1800 + 2200 Hz — the
          characteristic mid-frequency "ping" tail with a slight
          detuned overtone so the timbre has that PS1-era digital
          shimmer rather than a pure flute.
       3. 20ms echo tap at +80ms — adds the "digital reverb tail"
          shimmer without the cost of a convolver. */
  function _sh1Click() {
    if (!_ready || _muted) return;
    var c = _getCtx(); if (!c) return;
    var t = c.currentTime;

    /* 1. Metallic transient — 30ms bandpass noise burst @ 1700 Hz */
    var tickDur = 0.030;
    var tickN   = Math.ceil(c.sampleRate * tickDur);
    var tickBuf = c.createBuffer(1, tickN, c.sampleRate);
    var tickDat = tickBuf.getChannelData(0);
    for (var i = 0; i < tickN; i++) {
      tickDat[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / tickN, 0.8);
    }
    var tickSrc = c.createBufferSource(); tickSrc.buffer = tickBuf;
    var tickFlt = c.createBiquadFilter(); tickFlt.type = 'bandpass';
    tickFlt.frequency.value = 1700; tickFlt.Q.value = 4.5;
    var tickG = c.createGain(); tickG.gain.value = 0.20;
    tickSrc.connect(tickFlt); tickFlt.connect(tickG); tickG.connect(c.destination);
    tickSrc.start(t); tickSrc.stop(t + tickDur);

    /* 2. Sine tail — primary @ 1800Hz + detuned overtone @ 2200Hz */
    [{ f: 1800, a: 0.050 }, { f: 2200, a: 0.020 }].forEach(function (p) {
      var o = c.createOscillator(), g = c.createGain();
      o.connect(g); g.connect(c.destination);
      o.type = 'sine'; o.frequency.value = p.f;
      g.gain.setValueAtTime(p.a, t + 0.005);
      g.gain.exponentialRampToValueAtTime(0.0001, t + 0.005 + 0.28);
      o.start(t + 0.005); o.stop(t + 0.005 + 0.30);
    });

    /* 3. Echo tap @ +80ms — quieter repeat of the tick */
    var echoT = t + 0.080;
    var echoBuf = c.createBuffer(1, tickN, c.sampleRate);
    var echoDat = echoBuf.getChannelData(0);
    for (var ei = 0; ei < tickN; ei++) {
      echoDat[ei] = (Math.random() * 2 - 1) * Math.pow(1 - ei / tickN, 0.8);
    }
    var echoSrc = c.createBufferSource(); echoSrc.buffer = echoBuf;
    var echoFlt = c.createBiquadFilter(); echoFlt.type = 'bandpass';
    echoFlt.frequency.value = 1900; echoFlt.Q.value = 5.0;
    var echoG = c.createGain(); echoG.gain.value = 0.060;
    echoSrc.connect(echoFlt); echoFlt.connect(echoG); echoG.connect(c.destination);
    echoSrc.start(echoT); echoSrc.stop(echoT + tickDur);
  }

  /* ── Portal-enter (synthesized, SH-flavoured) ────────────────────────
     ~1.8s composite event for the EXPERIENCE → catalog reveal. Four
     stacked components:
       1. 0-250ms: low electromagnetic THUMP (80→45Hz sine decay) +
          lowpass rumble underneath — the "system engages" feel.
       2. 350ms-1300ms: detuned metallic bell triad (620/935/1240 Hz
          sines with slight ±0.5% detune for SH-style shimmer).
       3. 0-1800ms: subtle highpass static dust — keeps the entire
          event sitting on a thin film of tape noise.
       4. 1300-1600ms: clean signal-lock sine at 1480 Hz — the "system
          acquired" resolution. */
  function _shPortalEnter() {
    if (!_ready || _muted) return;
    var c = _getCtx(); if (!c) return;
    var t = c.currentTime;

    /* Music ducking — drop the player to 50% for the duration so the
       cue reads cleanly over the background track. */
    try { if (window._biosPlayerDuck) window._biosPlayerDuck(0.5, 1700); } catch (_) {}

    /* 1a. Low EM thump (80→45Hz sine decay) */
    var thumpO = c.createOscillator(), thumpG = c.createGain();
    thumpO.connect(thumpG); thumpG.connect(c.destination);
    thumpO.type = 'sine';
    thumpO.frequency.setValueAtTime(80, t);
    thumpO.frequency.exponentialRampToValueAtTime(45, t + 0.22);
    thumpG.gain.setValueAtTime(0.14, t);
    thumpG.gain.exponentialRampToValueAtTime(0.0001, t + 0.28);
    thumpO.start(t); thumpO.stop(t + 0.30);

    /* 1b. Low rumble (lowpass noise 0-400ms) */
    var rumbleDur = 0.45;
    var rN = Math.ceil(c.sampleRate * rumbleDur);
    var rBuf = c.createBuffer(1, rN, c.sampleRate), rDat = rBuf.getChannelData(0);
    for (var ri = 0; ri < rN; ri++) rDat[ri] = Math.random() * 2 - 1;
    var rSrc = c.createBufferSource(); rSrc.buffer = rBuf;
    var rFlt = c.createBiquadFilter(); rFlt.type = 'lowpass';
    rFlt.frequency.value = 220; rFlt.Q.value = 0.6;
    var rG = c.createGain();
    rG.gain.setValueAtTime(0, t);
    rG.gain.linearRampToValueAtTime(0.09, t + 0.06);
    rG.gain.exponentialRampToValueAtTime(0.0001, t + rumbleDur);
    rSrc.connect(rFlt); rFlt.connect(rG); rG.connect(c.destination);
    rSrc.start(t); rSrc.stop(t + rumbleDur);

    /* 2. Metallic bell triad — detuned sines for SH shimmer */
    var bellT = t + 0.35;
    [
      { f: 620,  a: 0.055, detune: -0.005 },
      { f: 935,  a: 0.042, detune:  0      },
      { f: 1240, a: 0.030, detune:  0.005 }
    ].forEach(function (p) {
      var o = c.createOscillator(), g = c.createGain();
      o.connect(g); g.connect(c.destination);
      o.type = 'sine'; o.frequency.value = p.f * (1 + p.detune);
      g.gain.setValueAtTime(0, bellT);
      g.gain.linearRampToValueAtTime(p.a, bellT + 0.10);
      g.gain.exponentialRampToValueAtTime(0.0001, bellT + 0.92);
      o.start(bellT); o.stop(bellT + 1.0);
    });

    /* 3. Static dust film (highpass noise, very low gain, 0-1.8s) */
    var dustDur = 1.80;
    var dN = Math.ceil(c.sampleRate * dustDur);
    var dBuf = c.createBuffer(1, dN, c.sampleRate), dDat = dBuf.getChannelData(0);
    for (var di = 0; di < dN; di++) dDat[di] = Math.random() * 2 - 1;
    var dSrc = c.createBufferSource(); dSrc.buffer = dBuf;
    var dFlt = c.createBiquadFilter(); dFlt.type = 'highpass';
    dFlt.frequency.value = 2200;
    var dG = c.createGain();
    dG.gain.setValueAtTime(0.018, t);
    dG.gain.linearRampToValueAtTime(0.010, t + 1.40);
    dG.gain.exponentialRampToValueAtTime(0.0001, t + dustDur);
    dSrc.connect(dFlt); dFlt.connect(dG); dG.connect(c.destination);
    dSrc.start(t); dSrc.stop(t + dustDur);

    /* 4. Clean signal lock — single sine ping at the end */
    var lockT = t + 1.30;
    var lockO = c.createOscillator(), lockG = c.createGain();
    lockO.connect(lockG); lockG.connect(c.destination);
    lockO.type = 'sine'; lockO.frequency.value = 1480;
    lockG.gain.setValueAtTime(0, lockT);
    lockG.gain.linearRampToValueAtTime(0.060, lockT + 0.04);
    lockG.gain.exponentialRampToValueAtTime(0.0001, lockT + 0.32);
    lockO.start(lockT); lockO.stop(lockT + 0.34);
  }

  function portalEnter() {
    /* No-op: theme.liquid's global HTML5 <audio> click handler covers
       this. Calling _sh1Click/buttonClick here on top of the WAV play
       was the source of the double-sound the user reported. */
  }
  function itemClick() { /* no-op — see portalEnter */ }

  /* ── Force-disable the remaining click-triggered synth cues ─────────
     Even with portalEnter/itemClick/overlayOpen/overlayClose stubbed,
     two more synths still fired on click:
       - pageStaticBurst() — bios-page-transitions.js calls on every
         internal-link click (a noise burst), AND bios-cursor.js fires
         it on the INNOCENCES wordmark click. That was the second
         sound the user heard alongside button_sounds.wav.
       - checkoutConnect() — fires on checkout-button clicks (modem
         handshake sequence). Also a click event → also doubles up.
     Replacing these public methods with no-ops at the very end of the
     IIFE (after all in-file callers like overlayClose's tail click
     are already bound to the *original* function references). The
     no-op assignment is on the returned API object below; the
     original function bodies stay defined for any future non-click
     trigger (e.g. a programmatic call from a future feature). */
  function _quietPageStaticBurst() { /* see comment above */ }
  function _quietCheckoutConnect() { /* see comment above */ }

  /* ── Universal click sound ────────────────────────────────────────────
     Plays the user-uploaded button_sounds.wav (registered as the
     'button-click' sample from theme.liquid) on every click. Rate-limit
     swallows back-to-back calls within 80ms so a single click event
     processed by multiple handlers (global capture + specific bubble)
     only fires the sample once. Falls back to _sh1Click() if the WAV
     hasn't downloaded yet — keeps clicks silent for ~half a second on
     first visit and then transparently swaps to the real file. */
  var _lastButtonClick = 0;
  function buttonClick() {
    var now = Date.now();
    if (now - _lastButtonClick < 80) return;
    _lastButtonClick = now;
    /* Force-unlock the AudioContext here since we KNOW we're inside a
       user gesture (this only fires from the global click handler).
       Without this, the first click was silent: _unlock runs in the
       bubble phase but our global handler runs in capture phase, so
       _ready was still false when _playSample checked it. */
    if (!_ready) {
      _ready = true;
      var c = _getCtx();
      if (c && c.state === 'suspended') {
        try { c.resume(); } catch (_) {}
      }
    }
    /* If the sample never loaded (e.g. registerSample raced the first
       click), retry the load now that the context is unlocked. */
    if (_sampleStatus['button-click'] !== 'ready' && _sampleUrls['button-click']) {
      _loadSample('button-click');
    }
    if (_playSample('button-click')) return;
    _sh1Click();
  }

  /* ── Diagnostic helper ──────────────────────────────────────────────
     Run `BiosAudioDebug()` in DevTools console to see the current audio
     state. If nothing's playing, this tells you exactly which gate is
     blocking: muted? context suspended? sample failed to load? */
  window.BiosAudioDebug = function () {
    var out = {
      muted: _muted,
      ready: _ready,
      contextState: _ctx ? _ctx.state : 'no-context',
      sampleUrls: _sampleUrls,
      sampleStatus: _sampleStatus,
      buffersLoaded: Object.keys(_sampleBuffers),
      gain: SAMPLE_GAIN,
      localStorageMute: null
    };
    try { out.localStorageMute = localStorage.getItem('bios_snd'); } catch (_) {}
    return out;
  };

  return {
    scanBeep:          scanBeep,
    portalTone:        portalTone,
    cartBeep:          cartBeep,
    lineBeep:          lineBeep,
    floppyLoad:        floppyLoad,
    typingTick:        typingTick,
    bootTone:          bootTone,
    crtHum:            crtHum,
    /* pageStaticBurst + checkoutConnect: exposed as no-ops to silence
       the click-triggered double-sound (called from
       bios-page-transitions.js + bios-cursor.js portal-home handler +
       multiple bios-main.js spots). Inner code that still references
       the real functions by closure (e.g. overlayClose's `scrollTick`
       tail) keeps using the bound originals — only the public surface
       is muted. */
    pageStaticBurst:   _quietPageStaticBurst,
    scrollTick:        scrollTick,
    seekNoise:         seekNoise,
    pageFlipSound:     pageFlipSound,
    highlightPiezo:    highlightPiezo,
    checkoutConnect:   _quietCheckoutConnect,
    overlayOpen:       overlayOpen,
    overlayClose:      overlayClose,
    cartRemove:        cartRemove,
    lowPowerEnter:     lowPowerEnter,
    lowPowerExit:      lowPowerExit,
    transmit:          transmit,
    designerEngage:    designerEngage,
    designerDisengage: designerDisengage,
    searchOpen:        searchOpen,
    duckMusic:         duckMusic,
    setMuted:          setMuted,
    isMuted:           isMuted,
    /* ── Sample-driven cues (registered from Liquid) ── */
    registerSample:    registerSample,
    portalEnter:       portalEnter,
    itemClick:         itemClick,
    buttonClick:       buttonClick
  };
})();

/* Universal click handler MOVED to theme.liquid as a plain HTML5 <audio>
   element. BiosAudio's Web Audio path was failing because the music
   plays via YouTube iframe (separate audio pipeline), so the user could
   hear music while Web Audio's AudioContext wasn't actually outputting.
   HTML5 <audio> uses the same media-element pipeline as the YouTube
   embed, so if music works the click sound works too. The buttonClick
   method on BiosAudio still exists for any caller that wants the
   Web-Audio-style cue (synth fallback chain), but the GLOBAL click
   handler is no longer wired here. */
